import { SERVER_FILE_ENDPOINT } from 'constants/envs';

/**
 * URL của khoá ảnh trên kho (vd. 'hp/<uuid>', 'gala/ve/12.png'). Server đổi khoá thành URL bằng cùng quy tắc
 * (CDN + '/' + khoá); danh sách vé và mẫu vé không kèm URL nên trình duyệt tự ghép.
 */
export function fileUrl(key: string | null | undefined): string {
  if (!key) return '';
  if (/^https?:\/\//i.test(key) || key.startsWith('data:')) return key;
  return `${SERVER_FILE_ENDPOINT}/${key.replace(/^\/+/, '')}`;
}
